import { create } from "zustand";
import { persist } from 'zustand/middleware';

const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      loggedIn: false,
      loginError: false,
      token: null,
      isAdmin: false,
      organization: null,
      setUser: (value) => set({ user: value }),
      updateUser: (value) => set((state) => ({ user: { ...state.user, ...value } })),
      setLoggedIn: (value) => set({ loggedIn: value }),
      setLoginError: (value) => set({ loginError: value }),
      setToken: (value) => set({ token: value }),
      setIsAdmin: (value) => set({ isAdmin: value }),
      setOrganization: (value) => set({ organization: value }),
    }),
    {
      name: 'auth-storage', // unique name
    }
  )
);

export default useAuthStore;